// Copyright 2020 Prescryptive Health, Inc.

import { useContext } from 'react';
import { IPostAuthContext, PostAuthContext } from './post-auth.context';

export const usePostAuthContext = (): IPostAuthContext =>
  useContext<IPostAuthContext>(PostAuthContext);
